import { cn } from "@/lib/utils";
import { PublicCategory } from "@/hooks/usePublicMenu";

interface TabletCategoryListProps {
  categories: PublicCategory[];
  selectedCategory: string;
  onSelectCategory: (categoryId: string) => void;
}

const CATEGORY_COLORS = [
  "from-rose-500/20 to-rose-600/20 border-rose-500/30",
  "from-amber-500/20 to-amber-600/20 border-amber-500/30",
  "from-emerald-500/20 to-emerald-600/20 border-emerald-500/30",
  "from-cyan-500/20 to-cyan-600/20 border-cyan-500/30",
  "from-violet-500/20 to-violet-600/20 border-violet-500/30",
  "from-pink-500/20 to-pink-600/20 border-pink-500/30",
  "from-blue-500/20 to-blue-600/20 border-blue-500/30",
  "from-orange-500/20 to-orange-600/20 border-orange-500/30",
];

const CATEGORY_ACTIVE_COLORS = [
  "from-rose-500 to-rose-600",
  "from-amber-500 to-amber-600",
  "from-emerald-500 to-emerald-600",
  "from-cyan-500 to-cyan-600",
  "from-violet-500 to-violet-600",
  "from-pink-500 to-pink-600",
  "from-blue-500 to-blue-600",
  "from-orange-500 to-orange-600",
];

export function TabletCategoryList({
  categories,
  selectedCategory,
  onSelectCategory,
}: TabletCategoryListProps) {
  return (
    <div className="flex gap-3 overflow-x-auto pb-2 scrollbar-hide">
      {/* All category */}
      <button
        onClick={() => onSelectCategory("all")}
        className={cn(
          "shrink-0 px-6 py-3 rounded-xl font-medium transition-all duration-200 border-2",
          selectedCategory === "all"
            ? "bg-gradient-to-r from-primary to-primary/80 text-primary-foreground border-primary shadow-lg shadow-primary/30"
            : "bg-slate-800/50 text-slate-300 border-slate-700 hover:border-primary/50"
        )}
      >
        Todos
      </button>

      {categories.map((category, index) => {
        const isActive = selectedCategory === category.id;
        const colorIndex = index % CATEGORY_COLORS.length;

        return (
          <button
            key={category.id}
            onClick={() => onSelectCategory(category.id)}
            className={cn(
              "shrink-0 px-6 py-3 rounded-xl font-medium transition-all duration-200 border-2",
              isActive
                ? `bg-gradient-to-r ${CATEGORY_ACTIVE_COLORS[colorIndex]} text-white border-transparent shadow-lg`
                : `bg-gradient-to-r ${CATEGORY_COLORS[colorIndex]} text-slate-200 hover:scale-105`
            )}
          >
            {category.name}
          </button>
        );
      })}
    </div>
  );
}
